export const ACCIONES = {
  LISTAR_TODOS: 'listarTodos',
  LISTAR_POR_ID: 'listarPorId',
  REGISTRAR: 'registrar',
  EDITAR: 'editar',
  ELIMINAR: 'eliminar',
};

export const CODIGOS_ESTADO_HTTP = {
  OK: 200,
  CREADO: 201,
  SIN_CONTENIDO: 204,
  PETICION_INCORRECTA: 400,
  NO_AUTORIZADO: 401,
  PROHIBIDO: 403,
  NO_ENCONTRADO: 404,
  METODO_NO_PERMITIDO: 405,
  ENTIDAD_NO_PROCESABLE: 422,
  ERROR_INTERNO_SERVIDOR: 500,
};

export const ESTADOS_HTTP = {
  [CODIGOS_ESTADO_HTTP.OK]: 'OK',
  [CODIGOS_ESTADO_HTTP.CREADO]: 'CREADO',
  [CODIGOS_ESTADO_HTTP.SIN_CONTENIDO]: 'SIN CONTENIDO',
  [CODIGOS_ESTADO_HTTP.PETICION_INCORRECTA]: 'PETICIÓN INCORRECTA',
  [CODIGOS_ESTADO_HTTP.NO_AUTORIZADO]: 'NO AUTORIZADO',
  [CODIGOS_ESTADO_HTTP.PROHIBIDO]: 'PROHIBIDO',
  [CODIGOS_ESTADO_HTTP.NO_ENCONTRADO]: 'NO ENCONTRADO',
  [CODIGOS_ESTADO_HTTP.METODO_NO_PERMITIDO]: 'MÉTODO NO PERMITIDO',
  [CODIGOS_ESTADO_HTTP.ENTIDAD_NO_PROCESABLE]: 'ENTIDAD NO PROCESABLE',
  [CODIGOS_ESTADO_HTTP.ERROR_INTERNO_SERVIDOR]: 'ERROR INTERNO DE SERVIDOR',
};

export const TIPOS_INSTITUCIONES = {
  UNIVERSIDAD: 'U',
  INSTITUTO: 'I',
};

export const TIPOS_CAMPOS = {
  TEXTO: 'text',
  NUMERO: 'number',
  FECHA: 'date',
  SELECCION_MULTIPLE: 'select',
};

export const TIPOS = [
  { text: 'Texto', value: TIPOS_CAMPOS.TEXTO },
  { text: 'Número', value: TIPOS_CAMPOS.NUMERO },
  { text: 'Fecha', value: TIPOS_CAMPOS.FECHA },
  { text: 'Opción múltiple', value: TIPOS_CAMPOS.SELECCION_MULTIPLE },
];

export const TEXTOS_TIPOS_CAMPOS = {
  [TIPOS_CAMPOS.TEXTO]: 'Texto',
  [TIPOS_CAMPOS.NUMERO]: 'Número',
  [TIPOS_CAMPOS.FECHA]: 'Fecha',
  [TIPOS_CAMPOS.SELECCION_MULTIPLE]: 'Opción múltiple',
};

export const ESTADOS_TIPO_DOCUMENTO_PERSONA = {
  PENDIENTE: 'pendiente',
  APROBADO: 'aprobado',
  RECHAZADO: 'rechazado',
};

export const ESTADOS_REVISIONES_ARRAY = [
  { text: 'Aprobado', value: ESTADOS_TIPO_DOCUMENTO_PERSONA.APROBADO },
  { text: 'Rechazado', value: ESTADOS_TIPO_DOCUMENTO_PERSONA.RECHAZADO },
];

export const PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA = {
  INSCRIPCION: 'inscripcion',
  TITULACION: 'titulacion',
  EMITIDO: 'emitido',
  RECEPCION: 'recepcion',
};

export const PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS = {
  [PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.INSCRIPCION]: 'Inscripción',
  [PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.TITULACION]: 'Titulación',
  [PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.EMITIDO]: 'Emitido',
  [PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.RECEPCION]: 'Recepción',
};

export const PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_ARRAY = [
  {
    text: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS[PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.INSCRIPCION],
    value: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.INSCRIPCION,
  },
  {
    text: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS[PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.TITULACION],
    value: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.TITULACION,
  },
  {
    text: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS[PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.EMITIDO],
    value: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.EMITIDO,
  },
  {
    text: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS[PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.RECEPCION],
    value: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.RECEPCION,
  },
];

export const FORMATOS_PERMITIDOS = {
  PDF: 'pdf',
  IMAGEN: 'imagen',
  PDF_E_IMAGEN: 'pdf_e_imagen',
};

export const FORMATOS_PERMITIDOS_TEXTOS = {
  [FORMATOS_PERMITIDOS.PDF]: 'PDF',
  [FORMATOS_PERMITIDOS.IMAGEN]: 'Imagen',
  [FORMATOS_PERMITIDOS.PDF_E_IMAGEN]: 'PDF e Imagen',
};

export const FORMATOS_PERMITIDOS_ARRAY = [
  { text: FORMATOS_PERMITIDOS_TEXTOS[FORMATOS_PERMITIDOS.PDF], value: FORMATOS_PERMITIDOS.PDF },
  { text: FORMATOS_PERMITIDOS_TEXTOS[FORMATOS_PERMITIDOS.IMAGEN], value: FORMATOS_PERMITIDOS.IMAGEN },
  { text: FORMATOS_PERMITIDOS_TEXTOS[FORMATOS_PERMITIDOS.PDF_E_IMAGEN], value: FORMATOS_PERMITIDOS.PDF_E_IMAGEN },
];

export const formatoImagen = 'image/png,image/jpg,image/jpeg';
export const formatoPdf = 'application/pdf';

export const MONEDAS = {
  BOB: 'BOB',
  USD: 'USD',
};

export const MONEDAS_TEXTOS = {
  [MONEDAS.BOB]: 'Bolivianos (BOB)',
  [MONEDAS.USD]: 'Dólares (USD)',
};

export const MONEDAS_OPCIONES = [
  { text: MONEDAS_TEXTOS[MONEDAS.BOB], value: MONEDAS.BOB },
  { text: MONEDAS_TEXTOS[MONEDAS.USD], value: MONEDAS.USD },
];
